import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Neue Modifizierer',
  tabs: {
    [Tab.General]: 'Allgemeines',
    [Tab.NutritionInfo]: 'Nährwertangaben',
  },
  form: {
    modifier_groups: {
      label: 'Gehört zu modifizierergruppen',
    },
    name: {
      label: 'Name',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: '{{integration}}-Referenz',
      placeholder: 'z. B. HubRise-SKU-Referenz',
      read_only_hint:
        'Nur bearbeitbar, solange eine HubRise-Integration verbunden und die Menüsynchronisierung deaktiviert ist.',
    },
    price: {
      label: 'Basis preis',
      placeholder: 'Optional',
    },
    is_available: {
      label: 'Auf Lager',
    },
    is_visible: {
      label: 'Sichtbar',
      title: 'Im Menü sichtbar',
      subtitle_on: 'Kunden sehen diese Option',
      subtitle_off: 'Für alle Kunden ausgeblendet',
    },
    is_available_for_pickup: {
      label: 'Für Abholung verfügbar',
      subtitle_on: 'Kunden können sie zur Abholung bestellen',
      subtitle_off: 'Im Abholmenü ausgeblendet',
    },
    is_available_for_delivery: {
      label: 'Für Lieferung verfügbar',
      subtitle_on: 'Kunden können sie zur Lieferung bestellen',
      subtitle_off: 'Im Liefermenü ausgeblendet',
    },
  },
  availability: {
    title: 'Verfügbarkeit',
    helper:
      'Sichtbarkeit ist der Hauptschalter. Schalte einen Kanal aus, um diese Option für Abhol- oder Lieferkunden auszublenden, ohne sie aus dem Menü zu entfernen.',
    status: {
      both: 'Beide Kanäle',
      pickup_only: 'Nur Abholung',
      delivery_only: 'Nur Lieferung',
      hidden: 'Ausgeblendet',
      no_channels: 'Keine Kanäle',
    },
    warning: {
      no_channels: 'Diese Option ist sichtbar, aber auf keinem Kanal verfügbar — Kunden können sie nicht auswählen.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Nur Abholung',
      delivery_only: 'Nur Lieferung',
      no_channels: 'Keine Kanäle',
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    changes_got_saved: 'Änderungen erfolgreich gespeichert!',
  },
};
